// extracted by mini-css-extract-plugin
export default {"input":"g2hyoo","wrapper":"fABmKm","checkbox":"q8FPq6","label":"KGZ6s5"};